// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__tFHYb","footer":"ModalError_footer__3pUtP"};